import {
  BooleanField,
  BooleanInput,
  Create,
  CreateButton,
  DataTable,
  DateField,
  DateInput,
  DateTimeInput,
  Edit,
  EditButton,
  ExportButton,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "@/components/admin";
import { useRecordContext } from "ra-core";
import { TopToolbar } from "../layout/TopToolbar";
import "./HR.css";

export const ListActions = ({ label = "Create" }: { label?: string }) => (
  <TopToolbar className="employee-list-header">
    <ExportButton className="btn-green-action" />
    <CreateButton label={label} className="btn-green-action" />
  </TopToolbar>
);

export const EditActions = () => (
  <TopToolbar>
    <EditButton className="btn-green-action" />
  </TopToolbar>
);

export const NeutralBadge = ({ source = "status" }: { source?: string }) => {
  const record = useRecordContext();
  const value = record?.[source];
  if (!value) return null;

  return (
    <div className={`status-bookmark ${value}`}>
      {String(value).replaceAll("_", " ")}
    </div>
  );
};

export {
  BooleanField,
  BooleanInput,
  Create,
  DataTable,
  DateField,
  DateInput,
  DateTimeInput,
  Edit,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput
};

